import { Suspense, lazy } from "react";
import ScrollToTop from "./helpers/scroll-top";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import WhatsAppButton from "./components/WhatsAppButton";
// home pages
const HomeFashion = lazy(() => import("./pages/home/HomeFashion"));
;
// const HomeCosmetics = lazy(() => import("./pages/home/HomeCosmetics"));
const LilyLux = lazy(() => import("./pages/home/LilyLux"));

const LilyBelle = lazy(() => import("./pages/home/LilyBelle"));


// product pages
const Product = lazy(() => import("./pages/shop-product/Product"));
const ProductTabLeft = lazy(() =>
  import("./pages/shop-product/ProductTabLeft")
);
const ProductTabRight = lazy(() =>
  import("./pages/shop-product/ProductTabRight")
);
const ProductSticky = lazy(() => import("./pages/shop-product/ProductSticky"));
const ProductSlider = lazy(() => import("./pages/shop-product/ProductSlider"));
const ProductFixedImage = lazy(() =>
  import("./pages/shop-product/ProductFixedImage")
);

// blog pages
const BlogStandard = lazy(() => import("./pages/blog/BlogStandard"));
const BlogNoSidebar = lazy(() => import("./pages/blog/BlogNoSidebar"));
const BlogRightSidebar = lazy(() => import("./pages/blog/BlogRightSidebar"));
const BlogDetailsStandard = lazy(() =>
  import("./pages/blog/BlogDetailsStandard")
);
const SelfCare = lazy(() =>
  import("./pages/blog/Self-Care")
);
const GelManicure = lazy(() =>
  import("./pages/blog/Gel-Manicure")
);
const Bouquet = lazy(() =>
  import("./pages/blog/Bouquet")
);


// other pages
const About = lazy(() => import("./pages/other/About"));
const Contact = lazy(() => import("./pages/other/Contact"));


const NotFound = lazy(() => import("./pages/other/NotFound"));

const App = () => {
  return (
    <>
      
      
      <WhatsAppButton /><Router>
      <ScrollToTop>
        <Suspense
          fallback={<div className="flone-preloader-wrapper">
            <div className="flone-preloader">
              <span></span>
              <span></span>
            </div>
          </div>}
        >
          <Routes>
            <Route
              path={process.env.PUBLIC_URL + "/"}
              element={<HomeFashion />} />

            {/* Homepages */}
            <Route
              path={process.env.PUBLIC_URL + "/home-fashion"}
              element={<HomeFashion />} />
          

            <Route
              path={process.env.PUBLIC_URL + "/lily-luxe"}
              element={<LilyLux />} />
           
            <Route
              path={process.env.PUBLIC_URL + "/LilyBelle"}
              element={<LilyBelle />} />
            {/* Shop product pages */}
            <Route
              path={process.env.PUBLIC_URL + "/product/:id"}
              element={<Product />} />
            <Route
              path={process.env.PUBLIC_URL + "/product-tab-left/:id"}
              element={<ProductTabLeft />} />
            <Route
              path={process.env.PUBLIC_URL + "/product-tab-right/:id"}
              element={<ProductTabRight />} />
            <Route
              path={process.env.PUBLIC_URL + "/product-sticky/:id"}
              element={<ProductSticky />} />
            <Route
              path={process.env.PUBLIC_URL + "/product-slider/:id"}
              element={<ProductSlider />} />
            <Route
              path={process.env.PUBLIC_URL + "/product-fixed-image/:id"}
              element={<ProductFixedImage />} />

            {/* Blog pages */}
            <Route
              path={process.env.PUBLIC_URL + "/blog-standard"}
              element={<BlogStandard />} />
            <Route
              path={process.env.PUBLIC_URL + "/blog-no-sidebar"}
              element={<BlogNoSidebar />} />
            <Route
              path={process.env.PUBLIC_URL + "/blog-right-sidebar"}
              element={<BlogRightSidebar />} />
            <Route
              path={process.env.PUBLIC_URL + "/blog-details-standard"}
              element={<BlogDetailsStandard />} />
            <Route
              path={process.env.PUBLIC_URL + "/Self-Care"}
              element={<SelfCare />} />
            <Route
              path={process.env.PUBLIC_URL + "/Gel-Manicure"}
              element={<GelManicure />} />
            <Route
              path={process.env.PUBLIC_URL + "/Bouquet"}
              element={<Bouquet />} />
            {/* Other pages */}
            <Route
              path={process.env.PUBLIC_URL + "/about"}
              element={<About />} />
            <Route
              path={process.env.PUBLIC_URL + "/contact"}
              element={<Contact />} />
            

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </ScrollToTop>
    </Router></>
  );
};

export default App;